<template>
  <div>
    <b-navbar type="light" variant="light" toggleable="lg" fixed="top">
      <b-navbar-brand class="navbar-brand" to="/efunding">
        <img src="../assets/images/efunding-logo.png" alt="logo-brand" class="ml-3" style="width: 200px;">
      </b-navbar-brand>

      <b-navbar-toggle target="nav-collapse"></b-navbar-toggle>
      <b-collapse id="nav-collapse" is-nav>
        <b-navbar-nav>
          <div>
            <b-nav-item-dropdown v-if="!userLoggedin || currentUser.info.role_id != 5" text="Produk" variant="primary"
              class="m-2 nav-item">
              <div v-for="(nl, index) in navlist" :key="index">
                <b-dropdown-item :to="nl.link">{{ nl.text }}</b-dropdown-item>
              </div>
            </b-nav-item-dropdown>
          </div>
        </b-navbar-nav>

        <div v-if="userLoggedin">
          <b-navbar-nav v-if="currentUser.info.role_id == 3 || currentUser.info.role_id == 4">
            <b-nav-item to="/pengajuan-saya">Pengajuan Saya</b-nav-item>
          </b-navbar-nav>
        </div>

        <div v-if="userLoggedin">
          <b-navbar-nav v-if="currentUser.info.role_id == 3 || currentUser.info.role_id == 4">
            <b-nav-item to="riwayat">Riwayat</b-nav-item>
          </b-navbar-nav>
        </div>

        <b-navbar-nav class="ml-auto" v-if="userLoggedin">
          <!-- Sesi dioper ke dashboard baru lewat goToNewDashboard(), jadi
               pengguna tidak perlu login ulang di sana. -->
          <b-nav-item href="#" @click.prevent="goToNewDashboard"
            class="nav-new-dashboard mr-3 d-flex align-items-center"
            link-classes="p-0">
            <div class="btn-new-dashboard">
              Coba Dashboard Baru ✨
            </div>
          </b-nav-item>
          <b-nav-item-dropdown right>
            <template #button-content>
              <span><b-icon icon="person-circle"></b-icon>{{ name }}</span>
            </template>
            <b-dropdown-item to="/dashboard" v-if="currentUser.info.role_id == 5">Dashboard</b-dropdown-item>
            <b-dropdown-item to="/pengajuan-saya?q=Profil" href="#"
              v-if="currentUser.info.role_id == 3 || currentUser.info.role_id == 4">Profil</b-dropdown-item>
            <b-dropdown-item @click="handleLogout">Sign Out</b-dropdown-item>
          </b-nav-item-dropdown>
        </b-navbar-nav>

        <b-navbar-nav class="ml-auto" v-else>
          <b-nav-item class="mr-2" @click="registerFormOpen">Daftar</b-nav-item>
          <b-nav-item to="/login">Login</b-nav-item>
        </b-navbar-nav>
      </b-collapse>
    </b-navbar>

    <!-- Modal Register Start -->
    <b-modal v-model="registerModal" no-stacking hide-header hide-footer centered>
      <div class="row">
        <div class="col border-right border-warning">
          <h3>Bergabung Sebagai Nasabah?</h3>

          <p>Bergabung dan dapatkan kemudahan menyimpan dana anda secara syariah di mitra-mitra kami</p>

          <b-button block @click="registerFunder = !registerFunder" variant="primary" class="border-0">Jadi
            Nasabah</b-button>
        </div>
        <div class="col">
          <h3>Bergabung Sebagai Mitra?</h3>

          <p>Bergabung dan naikkan produktifitas penawaran produk anda kepada customer</p>

          <b-button block @click="registerMitra = !registerMitra" variant="primary" class="border-0"> Jadi
            Mitra</b-button>
        </div>
      </div>
    </b-modal>
    <!-- Modal Register End -->

    <!-- Modal Register MItra Start -->
    <b-modal v-model="registerMitra" no-close-on-backdrop hide-footer size="lg" title="Daftar Mitra" scrollable>
      <div slot="modal-title">
        <img right :src='"../assets/images/efunding-logo.png"' alt="logo" width="200px">
        <span class="border-right border-warning mx-3"></span>
        Daftar Mitra
      </div>
      <div class="row">
        <div class="col">
          <ValidationObserver v-slot="{ handleSubmit }">
            <b-form @submit.prevent="handleSubmit(handleRegisterMitra)">
              <b-form-group label="Nama Lengkap PIC" label-for="fullname" invalid-feedback="Nama Harus Diisi!">
                <ValidationProvider name="Nama lengkap" rules="required" v-slot="{ errors }">
                  <b-form-input id="fullname" placeholder="Masukkan nama lengkap PIC"
                    v-model="mitra.name"></b-form-input>
                  <span class="text-danger">{{ errors[ 0 ] }}</span>
                </ValidationProvider>
              </b-form-group>

              <b-form-group label="Nama Organisasi / Perusahaan" label-for="fullname"
                invalid-feedback="Nama Harus Diisi!">
                <ValidationProvider name="Nama organisasi" rules="required" v-slot="{ errors }">
                  <b-form-input id="fullname" v-model="mitra.nama_organisasi_perusahaan"
                    placeholder="Masukkan nama organisasi"></b-form-input>
                  <span class="text-danger">{{ errors[ 0 ] }}</span>
                </ValidationProvider>
              </b-form-group>

              <b-form-group label="Email" label-for="email" invalid-feedback="Email Harus Diisi!">
                <ValidationProvider name="email" rules="required|email" v-slot="{ errors }">
                  <b-form-input id="email" v-model="mitra.email" placeholder="Masukkan email"
                    type="email"></b-form-input>
                  <span class="text-danger">{{ errors[ 0 ] }}</span>
                </ValidationProvider>
              </b-form-group>

              <b-form-group label="No Handphone" label-for="No Handphone" invalid-feedback="No Handphone Harus Diisi!">
                <ValidationProvider name="no telpon" rules="required" v-slot="{ errors }">
                  <b-form-input id="nohp" v-model="mitra.no_telpon" placeholder="Masukkan no handphone" type="number">
                  </b-form-input>
                  <span class="text-danger">{{ errors[ 0 ] }}</span>
                </ValidationProvider>
              </b-form-group>

              <b-form-group label="Jenis Mitra">
                <b-form-select v-model="mitra.e" :options="options" class="mb-3">
                </b-form-select>
                <b-form-checkbox class="mb-2 mr-sm-2 mb-sm-0">Saya telah Membaca dan Menyetujui <a
                    href="/syarat-dan-ketentuan" style="text-decoration: none; color: grey;">Syarat dan
                    Ketentuan</a></b-form-checkbox>

              </b-form-group>
              <VueRecaptcha ref="captcha" @verify="onVerify" @expired="onExpired" :sitekey="sitekey">
              </VueRecaptcha>
              <br>
              <b-button type="submit" block variant="primary" class="border-0">Daftar</b-button>
            </b-form>
          </ValidationObserver>
        </div>
      </div>
    </b-modal>
    <!-- Modal Register Mitra End -->

    <!-- Modal Register FUnder Start -->
    <b-modal v-model="registerFunder" id="modal-center" centered no-close-on-backdrop hide-footer size="lg"
      title="Daftar Nasabah" scrollable class="custom-modal">
      <div slot="modal-title" class="modal-logo">
        <img right :src='"../assets/images/efunding-logo.png"' alt="logo" width="200px">
        <span class="border-right border-warning mx-4 mb-7"></span>
        Pendaftaran Nasabah
      </div>
      <div class="col isian">
        <ValidationObserver v-slot="{ handleSubmit }">
          <b-form @submit.prevent="handleSubmit(handleRegisterFunder)">
            <b-form-group label="Nama Lengkap Sesuai KTP" label-for="fullname" invalid-feedback="Nama Harus Diisi!">
              <ValidationProvider name="Nama Lengkap" rules="required" v-slot="{ errors }">
                <b-form-input id="fullname" v-model="funder.name"
                  placeholder="Masukkan nama lengkap sesuai ktp"></b-form-input>
                <span class="text-danger ml-3">{{ errors[ 0 ] }}</span>
              </ValidationProvider>
            </b-form-group>

            <b-form-group label="Email" label-for="email" invalid-feedback="Email Harus Diisi!">
              <ValidationProvider name="Email" rules="required|email" v-slot="{ errors }">
                <b-form-input id="email" v-model="funder.email" placeholder="Masukkan email"
                  type="email"></b-form-input>
                <small class="text-danger ml-3">{{ errors[ 0 ] }}</small>
              </ValidationProvider>
            </b-form-group>

            <b-form-group label="Nomor Handphone" label-for="Nomor Handphone" invalid-feedback="No Handphone Harus Diisi!">
              <ValidationProvider name="Nomor Handphone" rules="required" v-slot="{ errors }">
                <vue-phone-number-input 
                  v-model="settings.phoneNumber"
                  default-country-code="ID"
                  :no-validator-state="true"
                  :translations="settings.phone_translations"
                  @update="updateFunderPhone"
                />
                <small class="text-danger ml-3">{{ errors[0] }}</small>
              </ValidationProvider>
            </b-form-group>

            <b-form-group label="Password" label-for="Password" invalid-feedback="Password Harus Diisi!">
              <ValidationProvider name="Password" rules="required|min:8|confirmed:confirmation" v-slot="{ errors }">
                <div class="input-group-append">
                  <input v-model="funder.password" v-bind:type="[ showPassword ? 'text' : 'password' ]"
                    class="form-control" placeholder="Password">
                  <span class="input-group-text toggle-password" @click="showPassword = !showPassword">
                    <i class="fa" :class="[ showPassword ? 'fa-eye' : 'fa-eye-slash' ]" aria-hidden="true"></i>
                  </span>
                </div>
                <small class="text-danger ml-3">{{ errors[ 0 ] }}</small>
              </ValidationProvider>
            </b-form-group>

            <b-form-group label="Konfirmasi Password" label-for="Password" invalid-feedback="Password Harus Diisi!">
              <ValidationProvider name="Konfirmasi Password" vid="confirmation" rules="required" v-slot="{ errors }">
                <div class="input-group-append">
                  <input v-model="funder.confirmpassword" v-bind:type="[ showConfirmPassword ? 'text' : 'password' ]"
                    class="form-control" placeholder="Masukkan Konfirmasi Password">
                  <span class="input-group-text toggle-password" @click="showConfirmPassword = !showConfirmPassword">
                    <i class="fa" :class="[ showConfirmPassword ? 'fa-eye' : 'fa-eye-slash' ]" aria-hidden="true"></i>
                  </span>
                </div>
                <small class="text-danger ml-3">{{ errors[ 0 ] }}</small>
              </ValidationProvider>
              <b-form-checkbox class="mb-2 mr-sm-2 mb-sm-0" v-model="termsAccepted">
                Saya telah Membaca dan Menyetujui
                <a href="/syarat-dan-ketentuan" style="color: #274C8F">Syarat dan Ketentuan</a>
              </b-form-checkbox>
            </b-form-group>

            <!-- <b-form-group label="Jenis Funder">
              <b-form-select v-model="funder.role_id" class="mb-3">
                <b-form-select-option disabled>Please select an option</b-form-select-option>
                <b-form-select-option selected value=3>Funder Personal</b-form-select-option>
                <b-form-select-option value=4>Funder Perusahaan</b-form-select-option>
              </b-form-select>
            </b-form-group> -->

            <div class="modal-recaptcha-container"> <!-- Kontainer untuk VueRecaptcha -->
              <VueRecaptcha ref="captcha" @verify="onVerify" @expired="onExpired" :sitekey="sitekey"></VueRecaptcha>
            </div>

            <br>
            <b-button block type="submit" variant="custom" class="border-0 custom-button"
              :disabled="!termsAccepted || !recaptchaVerified || loading">
              <template v-if="loading">
                <b-spinner small type="grow"></b-spinner> <!-- Loader -->
              </template>
              <template v-else>
                Daftar
              </template>
            </b-button>

          </b-form>
        </ValidationObserver>
      </div>
    </b-modal>
    <!-- Modal Register Funder End -->

    <b-modal size="sm" v-model="successModal" hide-footer hide-header>
      <div class="d-block text-center">
        <h3>Registrasi berhasil! Silahkan login</h3>
      </div>
      <b-button class="mt-3" variant="outline-success" block @click="hideSuccessModal">Tutup</b-button>
    </b-modal>
    <b-modal size="sm" v-model="failedModal" hide-footer hide-header>
      <div class="text-center failed-text mt-5">
        <h3 style="color: red;" v-html="failedMessage"></h3>
      </div>
      <b-button class="mt-5" block @click="hideFailedModal" style="color: #274C8F;">Oke</b-button>
    </b-modal>
    <b-modal size="sm" v-model="successModalMitra" hide-footer hide-header>
      <div class="d-block text-center">
        <h3>Terima kasih telah ingin bekerjasama dengan kami,</h3>
        <h3>Team kami akan menghubungi anda segera!</h3>
      </div>
      <b-button class="mt-3" variant="outline-success" block @click="hideSuccessModalMitra">Tutup</b-button>
    </b-modal>
  </div>
</template>


<script>

import Authentication from '../api/auth/authentication';
import JenisMitra from '../api/jenismitra';
import syaratketentuan from '../api/syaratketentuan';
import ProductCategory from '../api/productcategory';
import VueRecaptcha from 'vue-recaptcha';
import VuePhoneNumberInput from 'vue-phone-number-input';
import 'vue-phone-number-input/dist/vue-phone-number-input.css';

export default {
  name: 'Navbar',
  components: {
    VuePhoneNumberInput,
    VueRecaptcha
  },
  data() {
    return {
      settings:{
        phone_translations: {
          countrySelectorLabel: 'Negara',
          countrySelectorError: '',
          phoneNumberLabel: 'Nomor HP yang terhubung Whatsapp',
          example: 'Contoh :'
        },
        phoneNumber: null,
        isValid: false,
      },
      funder: {
        name: '',
        email: '',
        no_telpon: '',
        password: '',
        role_id: 3
      },
      mitra: {
        fullname: '',
        namaorganisasi: '',
        email: '',
        nohp: '',
        jenismitra_id: null
      },
      form: {
        search: ''
      },
      recaptchaVerified: false,
      termsAccepted: false,
      loading: false,
      showPassword: false,
      showConfirmPassword: false,
      loginModal: false,
      registerModal: false,
      registerFunder: false,
      registerMitra: false,
      selected: null,
      userLoggedin: false,
      name: '',
      successModal: false,
      successModalMitra: false,
      failedModal: false,
      failedMessage: "",
      options: [],
      syaratketentuan: '',
      navlist: [],
      logo: '',
      currentUser: '',
      sitekey: '6Lf0LVEaAAAAABqxdB_bDLHq-z8uuGzfiEPuDuBD',
      token: '',
      termsAccepted: false,
    }
  },
  created() {
    if (this.$store.state.auth.user) {
      this.currentUser = this.$store.state.auth.user
      this.userLoggedin = true;
      this.name = this.$store.state.auth.user.info.name
    }
  },
  mounted() {
    this.jenisMitraList();
    this.syaratKetentuan();
    this.navbarList();
    this.logo = '../assets/images/efunding-logo.png'
  },
  computed: {
  },
  methods: {
    handleLogout() {
      // Callback, bukan pemanggilan langsung: sebelumnya redirect terjadi lebih dulu
      // sehingga pembersihan sesi bisa keburu terpotong.
      this.$store.dispatch('auth/logout').then(() => {
        this.$router.push('/login');
      })
    },
    async goToNewDashboard() {
      const base = (process.env.NEW_DASHBOARD_URL || '').replace(/\/+$/, '');

      // Tanpa alamat tujuan, membuka tab hanya menyisakan halaman kosong.
      if (!base) {
        console.error('[SSO] NEW_DASHBOARD_URL belum diset pada build ini.');
        return;
      }

      const token = this.currentUser && this.currentUser.token;

      // Tab dibuka lebih dulu — dan secara sinkron, masih di dalam event klik —
      // supaya tidak diblokir popup blocker saat menunggu request kode selesai.
      // Sesi di dashboard lama sengaja dibiarkan hidup supaya pengguna bisa
      // bolak-balik selama masa percobaan.
      //
      // 'noopener' SENGAJA tidak dicantumkan sebagai fitur: menurut spesifikasi
      // HTML, window.open() wajib mengembalikan null begitu fitur itu diminta.
      // Pegangan ke tab-nya jadi hilang, tidak ada yang bisa mengisi
      // location-nya, dan tab tertinggal di about:blank. Hubungan opener
      // diputus manual di baris berikutnya — selagi tab masih about:blank dan
      // satu origin dengan halaman ini — yang memberi perlindungan sama.
      const tab = window.open('about:blank', '_blank');
      if (tab) tab.opener = null;

      // Kalau popup tetap diblokir, pakai tab yang sedang dibuka daripada
      // membiarkan kliknya terasa tidak berfungsi.
      const go = (url) => {
        if (tab) {
          tab.location = url;
        } else {
          window.location.href = url;
        }
      };

      if (!token) {
        go(base);
        return;
      }

      // Yang dioper cuma kode sekali pakai berumur 60 detik, BUKAN api_token.
      // Token asli berumur panjang: kalau URL-nya bocor (ekstensi browser,
      // session restore, screenshot, URL yang tak sengaja dibagikan), akunnya
      // ikut terbawa berminggu-minggu. Kode ini hangus begitu ditukar dan hanya
      // bisa ditukar dari browser yang sama.
      try {
        const res = await Authentication.issueSsoHandoffCode();
        const code = res.data && res.data.data && res.data.data.code;

        if (!code) throw new Error('Kode serah-terima tidak diterima');

        // Fragment, bukan query string: fragment tidak pernah dikirim ke server,
        // jadi tidak masuk access log maupun header Referer.
        go(base + '/sso#code=' + encodeURIComponent(code));
      } catch (err) {
        // Gagal menerbitkan kode bukan alasan menahan pengguna: buka dashboard
        // baru apa adanya, mereka tinggal login di sana.
        console.error('[SSO] Gagal menerbitkan kode serah-terima:', (err && err.message) || err);
        go(base);
      }
    },
    updateFunderPhone(value) {
      // console.log("UPDATE FUNDER PHONE DETECTED", value);
      // console.log("IS VALID", value.isValid);
      if (value.isValid) {
        this.settings.isValid = true;
        // console.log('GET COUNTRY CALLING CODE', value.countryCallingCode);
        // console.log('GET NATIONAL NUMBER', value.nationalNumber);
        this.funder.no_telpon = value.countryCallingCode + value.nationalNumber;
      } else {
        this.settings.isValid = false;
      }
    },
    handleRegisterFunder() {
      Object.assign(this.funder, { token: this.token });
      this.loading = true;

      this.$store.dispatch('auth/register', this.funder)
        .then(res => {
          if (res.meta.code !== 200) {
            console.error('failed to register');
            this.registerFunder = false;
            this.registerModal = false;
            this.failedModal = true;
            this.failedMessage = res.meta.messages + '<br>' + res.data.join('<br>');  
          } else {
            this.registerFunder = false;
            this.registerModal = false;
            this.successModal = true;
            this.loading = false;
          }
        })
        .catch(err => {
          console.error('failed to register', err);
          this.failedMessage = "Terjadi kesalahan saat registrasi. Silakan coba lagi.";
          this.failedModal = true;
        });
    },
    handleRegisterMitra() {
      Object.assign(this.mitra, { token: this.token })
      this.$store.dispatch('auth/registerMitra', this.mitra)
        .then(res => {
          if (res.meta.code != 200) console.error('failed to register')
          this.registerMitra = false;
          this.registerModal = false;
          this.successModalMitra = true;
        })
        .catch(err => {
          console.error(err)
        })
    },
    hideSuccessModal() {
      this.successModal = false;
      this.$router.push('/login');
    },
    hideSuccessModalMitra() {
      this.successModalMitra = false;
    },
    registerFormOpen() {
      this.registerFunder = true;
    },
    hideFailedModal() {
      this.failedModal = false;
      this.registerFunder = true;
      this.loading = false;
    },
    jenisMitraList() {
      JenisMitra.index()
        .then(res => {
          let resData = res.data.data.data;
          const arrData = [];
          for (let i = 0; i < resData.length; i++) {
            arrData.push({
              value: resData[ i ].id,
              text: resData[ i ].name
            });
          }
          this.options = arrData;
          this.mitra.jenismitra_id = arrData[ 0 ].value
        })
        .catch(err => console.log(err))
    },
    searchNav() {
      // console.log('here')
      this.$router.push('/list-produk?search=' + this.form.search);
      location.reload()
    },
    syaratKetentuan() {
      syaratketentuan.index()
        .then(res => {
          let resData = res.data.data;
          // Tambahkan pengecekan sebelum mengakses `isi`
          this.syaratketentuan = resData.length > 0 && resData[ 0 ].isi ? resData[ 0 ].isi : 'Syarat dan ketentuan belum tersedia';
        })
        .catch(err => {
          console.error("Gagal mengambil syarat dan ketentuan:", err);
          this.syaratketentuan = 'Syarat dan ketentuan tidak dapat dimuat';
        });
    },
    navbarList() {
      ProductCategory.index()
        .then(res => {
          const resData = res.data.data.data;
          const arrData = [];

          for (let i = 0; i < resData.length; i++) {
            const item = resData[i];
            const name = item.name.toLowerCase();

            if (name === "pembiayaan") continue; // Skip kategori Pembiayaan

            let link = `/list-produk?category=${item.id}`; // default
            if (name === "deposito") link = "/list-produk-deposito";
            else if (name === "tabungan") link = "/list-produk-tabungan";

            arrData.push({
              value: item.id,
              text: item.name,
              link: link
            });
          }

          this.navlist = arrData;
        })
        .catch(err => console.log(err));
    },
    onVerify(response) {
      this.token = response
      this.recaptchaVerified = true;
    },
    onExpired() {
      this.recaptchaVerified = false;
    }
  }
}
</script>

<style>
.syarat-ketentuan {
  border: 1px solid;
  height: 300px;
  margin-bottom: 20px;
  /* display: flex; */
  overflow: scroll;
}

.navbar-toggler.collapsed {
  background-color: transparent;
}

.navbar.navbar-light.bg-light {
  background-color: #fff !important;
}

a:visited {
  text-decoration: none;
}

.modal-logo {
  margin: 10px 10px 10px 30px;
}

.isian {
  margin: auto;
  padding: 20px;
}

.toggle-password {
  color: #F6BC3C;
  background-color: #274C8F;
  font-size: large;
}

.modal-recaptcha-container {
  display: flex;
  justify-content: center;
  /* Menempatkan konten di tengah secara horizontal */
  align-items: center;
  /* Menempatkan konten di tengah secara vertikal */
  margin: 20px 0;
  /* Tambahkan margin atas dan bawah jika perlu */
}

.custom-modal {
  border-radius: 10rem;
  /* Atur radius border modal */
}

.custom-button {
  background-color: #274C8F;
  /* Mengubah warna latar belakang tombol */
  color: white;
  /* Mengubah warna teks tombol agar terlihat jelas */
}

/* Tombol "Coba Dashboard Baru".
   Disalin dari design system new-efunding (src/components/ui/Button.css —
   gabungan .btn + .btn--primary + .btn--md) supaya pintu masuk ke dashboard
   baru sudah tampil dengan bahasa visual dashboard yang dituju.
   Nilai token (--color-primary: #274c8f, --color-primary-dark: #1a3668,
   --color-primary-glow) ditulis literal karena project ini belum memakai CSS
   custom property. Nama kelasnya sengaja bukan `.btn`: kelas itu sudah dipakai
   Bootstrap di sini dan akan saling menimpa. */
.btn-new-dashboard {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  border: none;
  border-radius: 14px;
  font-family: inherit;
  font-weight: 600;
  font-size: 0.875rem;
  padding: 10px 22px;
  white-space: nowrap;
  cursor: pointer;
  position: relative;
  overflow: hidden;
  background: linear-gradient(135deg, #274c8f 0%, #1a3668 100%);
  color: #ffffff;
  transition: all 0.25s cubic-bezier(0.4, 0, 0.2, 1);
}

/* Tanpa box-shadow, beda dari .btn--primary di new-efunding: di navbar terang
   ini glow birunya terbaca sebagai bayangan yang mengganggu. Umpan balik hover
   cukup dari angkatan 2px + brightness. */
.btn-new-dashboard:hover {
  transform: translateY(-2px);
  filter: brightness(1.1);
}

.btn-new-dashboard:active {
  transform: translateY(0);
}

/* <b-nav-item> membungkus tombol jadi <li class="nav-item"><a class="nav-link">.
   Keduanya dipaksa polos: .nav-link bawaan Bootstrap punya padding .5rem 1rem,
   yang menyisakan bidang di sekeliling tombol — begitu bidang itu terwarnai
   (hover, focus, atau :active) ia terbaca sebagai kotak biru mengelilingi
   tombol. Hanya .btn-new-dashboard yang boleh menggambar bentuk. */
.nav-new-dashboard,
.nav-new-dashboard .nav-link,
.nav-new-dashboard .nav-link:hover,
.nav-new-dashboard .nav-link:focus,
.nav-new-dashboard .nav-link:active {
  padding: 0 !important;
  background: transparent !important;
  background-color: transparent !important;
  box-shadow: none !important;
  outline: none !important;
  border: none !important;
  color: #ffffff;
}
</style>



// WEBPACK FOOTER //
// src/components/navbar.vue